import { useEffect } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import * as server from './server';
import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchComponent = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();
    const isRefetchNeeded = useDynamicReducerSelector(prop('isRefetchNeeded'));

    useEffect(() => {
        if (!isMounted() || !isRefetchNeeded) {
            return;
        }

        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError({ error: '' }));

        (async () => {
            try {
                const response = await server.getTimeSlotExclusions();
                const { revision, scheduledBreaks } = helpers.parseScheduledBreaksResponse(response);

                isMounted() && dispatch(actions.setScheduledBreaksData({ revision, scheduledBreaks }));
            } catch (error) {
                const errorMsg = getErrorMessage(error);

                isMounted() && dispatch(actions.setError({ error: errorMsg, isFetchError: true }));
            } finally {
                if (isMounted()) {
                    dispatch(actions.toggleLoading(false));
                    dispatch(actions.toggleIsRefetchNeeded(false));
                }
            }
        })();
    }, [dispatch, isMounted, isRefetchNeeded, getErrorMessage]);
};
